module.exports = __webpack_public_path__ + "graphics/platform-modding.ckh.5b600af0229ba5c844201b064c4e87a4.png";